module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av14-112cf691b60db72a53b00231ef86c0ba.jpg";